import React, { useState, useReducer, useContext } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import { Box, Tooltip, TextField } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import dayjs from 'dayjs'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TlsButton } from '../../Settings/Email';

const url = '/subscripts/'

export const translate_permissions_keys = {
    'Can': '',
    'add': 'Adicionar',
    'change': 'Alterar',
    'delete': 'Excluir',
    'view': 'Ver'
}

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`SubScript ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        Object.assign(data, {...data, ...res.data})
        getData()
        setLoader(false)
        return
    }
    toast.error(`SubScript não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: `)
    setLoader(false)
}


const EditSubScriptsModal = ({ data, handleClose, permissions, reloadData }) => {

    const { setLoader } = useContext(externalComponent)

    const [error, setError] = useState('')

    const [state, setState] = useReducer(lockedReducer, {
        id: data.id ? data.id : 0,
        name: data.name ? data.name : '',
        script: data.script ? data.script : '',
    })


    const validData = validateData(state)

    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: 'md' }}
                title={
                    `${getTitle(state)} SubScripts`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' sx={{ overflow: 'hidden' }}>
                            <Box className='item-profile-row'>
                                <TextField
                                    id="name"
                                    type="text"
                                    label="Nome"
                                    value={state.name}
                                    onChange={(e) => { setState({ 'name': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>

                            <Box className='item-profile-row textareascroll'>
                                <TextField
                                    label="Script"
                                    multiline
                                    fullWidth={false}
                                    rows={window.innerHeight / 80}
                                    size="small"
                                    value={state.script}
                                    onChange={(e) => { setState({ 'script': e.target.value }) }}
                                    inputProps={{ maxLength: 5000 }}
                                />
                            </Box>
                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />
        </>
    )
}

export default EditSubScriptsModal